import { render, staticRenderFns } from "./wtDropdown.component.vue?vue&type=template&id=3a4651a8&"
import script from "./wtDropdown.component.vue?vue&type=script&lang=js&"
export * from "./wtDropdown.component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports